export function formatNumber(number) {
	return number.toLocaleString("en");
}

export function formatDate(date) {
	const time = new Date(date);
	const options = { year: "numeric", month: "long", day: "numeric" };

	return time.toLocaleDateString("en-AU", options);
}



// WEBPACK FOOTER //
// ./src/utils/numbersAndStrings.js